// extracted by mini-css-extract-plugin
export default {"updateTitleCustom":"ResendTrack_updateTitleCustom__4V1Zp","helpTextCustom":"ResendTrack_helpTextCustom__ii0-J"};